import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
 .gd-bem {
   position: relative;
    width: 100%;
    height: calc(100vh - 176px);
    overflow: hidden;

    @media only screen and (min-width: 1340px) {
      height: calc(100vh - 161px); 
    }

    * {
      font-family: "Futura W01", sans-serif !important;
      box-sizing: border-box;
      font-size: 100%;
    }

    a {
      text-decoration: none;
      color: inherit;
    }
    article,
    aside,
    details,
    figcaption,
    figure,
    footer,
    header,
    menu,
    nav,
    section,
    summary {
      display: block;
    }
    audio,
    canvas,
    progress,
    video {
      display: inline-block;
    }
    audio:not([controls]) {
      display: none;
      height: 0;
    }
    progress {
      vertical-align: baseline;
    }
    [hidden],
    template {
      display: none;
    }
    a {
      background-color: transparent;
      -webkit-text-decoration-skip: objects;
    }
    a:active,
    a:hover {
      outline-width: 0;
    }
    abbr[title] {
      border-bottom: none;
      text-decoration: underline;
      text-decoration: underline dotted;
    }
    b,
    strong {
      font-weight: inherit;
      font-weight: bolder;
    }
    dfn {
      font-style: italic;
    }
    h1 {
      font-size: 2em;
      margin: 0.67em 0;
    }
    mark {
      background-color: #ff0;
      color: #000;
    }
    small {
      font-size: 80%;
    }
    sub,
    sup {
      font-size: 75%;
      line-height: 0;
      position: relative;
      vertical-align: baseline;
    }
    sub {
      bottom: -0.25em;
    }
    sup {
      top: -0.5em;
    }
    img {
      border-style: none;
    }
    svg:not(:root) {
      overflow: hidden;
    }
    code,
    kbd,
    pre,
    samp {
      font-family: monospace, monospace;
      font-size: 1em;
    }
    figure {
      margin: 1em 40px;
    }
    hr {
      box-sizing: content-box;
      height: 0;
      overflow: visible;
    }
    button,
    input,
    optgroup,
    select,
    textarea {
      font: inherit;
      margin: 0;
    }
    optgroup {
      font-weight: 700;
    }
    button,
    input {
      overflow: visible;
    }
    button,
    select {
      text-transform: none;
    }


    aside {
      position: absolute;
      left: 0px;
      top: 0px;
      width: 275px;
      padding-top: 15px;
      z-index: 50;
  
      @media only screen and (max-width: 960px) {
        width: 100%;
        padding-top: 26px;
  
        &.contact, &.features, &.components, &.workflow {
          .canHide {
            display: none;
          }
        }
      }

      @media only screen and (max-width: 1440px) {
        &.contact {
          > h2 {
            margin-top: 15px !important;
          }
        }
      }
  
      
    }

  main {
    position: relative;
    z-index: 25;
    padding-left: 300px;
    
    @media only screen and (max-width: ${p => p.theme.break}px) {
      padding-left: 0px;
    }
  }

  .scene {
    width: 100%;
    height: 0px;
    background: transparent;
    transform-origin: left center;
  }

  .sceneContent {
    position: absolute;
    left:0;
    top: 0;
    width: 100%;
    height: 100vh;
    max-height: calc(100vh - 176px);
    padding-top: 35px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding-left: 300px;
    z-index: 20;

    &.start {
      margin-left: 70px;
    }

    &.contact {
      margin-left: 70px;
      pointer-events: none;

      @media only screen and (max-width: 1440px) {
        > img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      @media only screen and (max-width: 960px) {
        display: none;
      }
    }

    @media only screen and (max-width: 1440px) {
      > div {
        transform: scale(0.85);
        transform-origin: center center;

        &[class*="sc-"] {
            height: auto !important;
        }
      }
      /* .image-360 {
        height: 100%;
      }
      .img-frames {
        width: 85% !important;
        height: 85%;
      }
      .image-360,
      .img-frames {
        object-fit: contain;
 
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      } */
    }

    @media only screen and (max-height: 720px) and (orientation: landscape) {
        > div {
            transform: scale(0.65);
        }
    }

    @media only screen and (max-height: 640px) and (orientation: landscape) {
        > div {
            transform: scale(0.55);
        }
    }

    @media only screen and (max-width: ${p => p.theme.break}px) {
      max-height: calc(100vh - 176px);
      padding-top: 130px;
      padding-left: 0px;

      &.contact {
        justify-content: flex-end;
        margin-left: 0px;
      }
    }

    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      display: block!important;
      padding-top: 140px!important;
      &.start, &.contact {
        padding-top: 0px!important;
      }
    }

    &.workflow {
      z-index: 60!important;
    }
  }

  @media only screen and (max-width: ${p => p.theme.break}px) {
    .hideMobile {
      display: none!important;
    }
  }

  @media only screen and (min-width: ${p => p.theme.break - 12}px) {
    .hideDesktop {
      display: none!important;
    }
  }

  .hideImage {
    transform: translate3d(200vw, 0,0)!important;
  }

  .scrollmagic-pin-spacer {
    pointer-events: none;
  }

  .fixedWrap {
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100vw;
    height: 1px;
  }

  h1, h2,h3,h4,h5,p,span {
    font-size: 1.1rem;
    margin: 0;
    padding: 0;
    color: ${p => p.theme.colors.text};
    @media only screen and (max-width: ${p => p.theme.break}px) {
      font-size: 0.9rem;
    }
  }

  span {
    font-size: 1.1rem;
    margin: 0;
    padding: 0;
    color: ${p => p.theme.colors.text};
    @media only screen and (max-width: ${p => p.theme.break}px) {
      font-size: 0.9rem;
    }
  }

  h1 {
    font-size: 4.2rem;
    transform: translate3d(0, 0, 0);
    font-weight: 500!important;
    @media only screen and (max-width: ${p => p.theme.break}px) {
      font-size: 2.8rem;
      line-height: 40px;
    }
  }

  h2 {
    font-weight: 500!important;
    font-size: 1.6rem;
    line-height: 2rem;
  }



  p.small {
    font-size: 0.8rem;
    line-height: 1.1rem!important;
    color: ${p => p.theme.colors.lightText};

    @media only screen and (max-width: ${p => p.theme.break}px) {
      margin-top: 10px !important;
    }
  }

  .img-frames {
    transition: 2500ms transform ease-in-out;
    transform: translate3d(0, 0, 0) scale(1)!important;
    @media only screen and (max-width: ${p => p.theme.break}px) {
      transform: translate3d(-10px, -50px) scale(1.2)!important;
    }
  }

  .scale-11 {
    transform: scale(1.1)!important;
  }

  .scale-12 {
    transform: scale(1.2)!important;
    @media only screen and (max-width: ${p => p.theme.break}px) {
      transform: translate3d(-10px, -50px) scale(1.5)!important;
    }
  }

  .scale-13 {
    transform: scale(1.3)!important;
  }

  .scale-14 {
    transform: scale(1.4)!important;
  }

  .scale-15 {
    transform: scale(1.5)!important;
    @media only screen and (max-width: ${p => p.theme.break}px) {
      transform: translate3d(-10px, -50px, 0) scale(1.7)!important;
    }
  }

  .scale-16 {
    transform: scale(1.6)!important;
  }

  .scale-17 {
    transform: scale(1.7)!important;
  }

  .scale-18 {
    transform: scale(1.8)!important;
  }

  .scale-19 {
    transform: scale(1.9)!important;
  }

  .scale-20 {
    transform: scale(2)!important;
  }

  .hidable {
    transition: 300ms opacity ease-in-out;
    -webkit-backface-visibility: hidden;
    opacity: 1;
    pointer-events: all;

    &.hide {
      opacity: 0;
      pointer-events: none!important;
    }
  }

  .text {
    position: absolute;
    width: 80%;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    z-index: 999;

    .title {
      font-size: 1.1rem;
    }

    span {
      min-width: 200px;
      font-size: 1rem;
    }

  }

  .image-360 {
    @media only screen and (max-width: ${p => p.theme.break}px) {
      transform: translate3d(-60px, 0, 0) scale(1.3)!important;
    }
  }

  .qi-tooltip {
    background: rgba(207,217,232,0.8)!important;
    color: ${p => p.theme.colors.link}!important;
    backdrop-filter: blur(6px);
    margin-bottom: 20px!important;
    font-size: 1rem!important;
    padding: 15px 22px!important;
    line-height: 1.5rem!important;
    max-width: 375px;

    &:after {
      border-top-color: rgba(207,217,232,0.7)!important;
    }

    b {
      padding-bottom: 5px!important;
      font-weight: 700!important;
    }

    @media only screen and (max-width: ${p => p.theme.break}px) {
      max-width: 275px;
    }
  }

  .tip {
    position: absolute;
    width: 44px;
    height: 44px;
    background: rgba(207,217,232,0.9);
    border-radius: 50%!important;
    border: 2px solid #FFF;
    z-index: 999;
    transition: 300ms all ease-in-out;
    -webkit-backface-visibility: hidden;
    transform: scale(0);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;

    &.show {
      transform: scale(1);
      opacity: 1;
    }

    &.hide {
      transform: scale(0);
    }

    &:before {
      content: "";
      position: absolute;
      left: calc(-50% - 1px);
      top: calc(-50% - 1px);
      width: 200%;
      height: 200%;
      background: rgba(207,217,232,0.35);
      border: 1px dashed #FFF;
      border-radius: 50%;
      transform: scale(0.66);
      transition: 300ms all ease-in-out;
      -webkit-backface-visibility: hidden;
      z-index:-1;
      opacity: 0;
      transform-origin: center center;
    }

    .icon {
      position: absolute;
      top: 30%;
      left: 30%;
      width: 40%;
      height: 40%;
      opacity: 0;
      transition: 300ms all ease-in-out;
    }

    &:hover, &.hover {
      transform: scale(1.1)!important;

      .icon {
        opacity: 1;
      }

      &:before {
        transform: scale(1)!important;
        opacity: 1!important;
        border: 1px dashed #FFF;
      }
    }
  }

  .sticky {
    -webkit-backface-visibility: hidden;
    -webkit-transform:translate3d(0,0,0);
  }

  .scrollmagic-pin-spacer{
    top:0 !important
 }

 .qi-button {
  display: inline-block;
  margin-top: 13px;
  line-height: 48px;
  height: 45px;
  width: 140px;
  font-size: 0.9rem;
  background-color: ${p => p.theme.colors.highlight};
  color: #fff;
  background-clip: padding-box;
  -webkit-border-radius: 5px;
  border-radius: 11px;
  text-transform: uppercase;
  text-align: center;
  text-decoration: none;
   &--inverted {
     color: ${p => p.theme.colors.highlight};
     border: 1px solid ${p => p.theme.colors.highlight};
     background-color: #fff;
   }
 }

 .contactBox {
   margin-top: 75px;

   @media only screen and (max-width: 1440px) {
    margin-top: 20px;

    p {
      line-height: 1.5rem;
    }

    + p {
      margin-top: 15px !important;
    }

    .row {
      margin-top: 1rem !important;
    }

    .qi-button {
        margin-top: 4px;
    }
   }

   @media only screen and (max-width: 1024px) {
    padding: 0 18px;

    + p {
      padding: 0 18px;
    }
   }
 }

 .link {
  display: block;
  margin-top: 13px;
  font-size: 20px;
  font-weight: normal;
  color: #1b3167;
  text-decoration: none;
 }


 .row {
   display: flex;
   flex-direction: row;
   margin-left: 0;
   margin-right: 0;
 }

 .col {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.fp-tableCell {
  position: relative;
}


.scroll-downs {
  position: absolute;
  left: 0;
  bottom: 20px;
  width: 100vw;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  pointer-events: none;

  @media only screen and (max-width: 1440px) {
    display: none;
  }

  .mousey {
    position: relative;
    width: auto;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  
    span {
      font-size: 0.9rem;
      color: #AEADB3;
    }
  
    .arrow-down {
      width: 80px;
       height: auto;
       animation-name: scroll;
    animation-duration: 2.2s;
    animation-delay: 2s;
    animation-timing-function: cubic-bezier(.15,.41,.69,.94);
    animation-iteration-count: infinite;
    }
  }

  @media only screen and (max-width: ${p => p.theme.break}px) {
    transform: scale(0.7)!important;
    bottom: 5px;
  }
}


.scroller {
  position: absolute;
  left: calc(50% - 2px);
  top: 10px;
  width: 4px;
  border-radius: 5px;
  height: 8px;
  background-color: ${p => p.theme.colors.link};
  animation-name: scroll;
  animation-duration: 2.2s;
  animation-timing-function: cubic-bezier(.15,.41,.69,.94);
  animation-iteration-count: infinite;
}
@keyframes scroll {
  0% { opacity: 0; }
  10% { transform: translateY(0); opacity: 1; }
  100% { transform: translateY(15px); opacity: 0;}
}

  #fullpage {
    pointer-events: none;
    
  }

  .section {
    height: 0px!important;
  }

  .playerIE {
    width: 100vw!important;
    height: 100%!important;
    background-color: transparent!important;

    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      background-color: #FFF!important;
    }
  }
}
`;
